<app-dialog-base [Title]='"Input binding history"|translate' [dialogId]="dialogId" (onClose)="close()" (onSubmit)="submit()" [width]="'500px'">
  <div class="table">
    <table fixedcols="[2]">
      <tr>
        <th>{{'Time'|translate}}</th>
        <th>{{'Input'|translate}}</th>
        <th> <button class="btn_img btn_graygray btn_plusorange" (click)="addLine()"></button></th>
      </tr>
      <tr *ngFor="let binding of model.TrendBindingHistory">
        <td>
          <calendar [name]="getCalendarName(binding)" [(date)]="binding.Time" [format]="'%0D.%0M.%0Y %0h:%0m:%0s'"></calendar>
        </td>
        <td>
          <app-trend-input [(Input)]="binding.Input" [Inputs]="Inputs"></app-trend-input>
        </td>
        <td>
          <button (click)="deleteBinding(binding)" class="btn_img btn_remove"></button>
        </td>
      </tr>
    </table>
  </div>

</app-dialog-base>
